import preventDefault from '../../helpers/preventDefault';
import styles from './NoResource.module.scss';
import logoUrl from './assets/logo.svg';
import { useTranslation } from 'react-i18next';

const NoResource = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.page}>
      <div className={styles.center}>
        <div onClick={preventDefault}>
          <img src={logoUrl} alt="Glaze" />
          <h1>{t('Incorrent parameters.')}</h1>
          <h2>{t('Go to main page and click directly on link to start painting.')}</h2>
        </div>
      </div>
    </div>
  );
};

export default NoResource;
